// @flow
import React, { Component } from 'react';
import Routes from './routes/Routes';

// Themes
import './assets/scss/Saas.scss';
import './assets/scss/first-class-data.scss';
import 'rsuite-table/dist/css/rsuite-table.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import './assets/scss/rsuite-slider.css';


type AppProps = {};

/**
 * Main app component
 */
class App extends Component<AppProps> {
    render() {
        return <Routes></Routes>;
    }
}

export default App;
